@if (total() > perPage()) {
  <sdc-pagination
    data-cy="pagination"
    [page]="current()"
    [totalItems]="total()"
    [pageSize]="perPage()"
    [label]="label()"
    (pageChange)="goto($event)" />
}
